import { Text, Tooltip } from "@merge-api/merge-javascript-shared";
import { Info, ArrowUp, ArrowDown } from "lucide-react";
import {
  AlertDashboardColumn,
  AlertDashboardColumnTooltip,
  SORTABLE_COLUMNS,
} from "./utils/constants";

interface AlertDashboardColumnTitleProps {
  column: AlertDashboardColumn;
  isSorted?: boolean;
  sortDirection?: "asc" | "desc" | undefined;
  handleSort?: (field: AlertDashboardColumn | null) => void;
}

const AlertDashboardColumnTitle = ({
  column,
  isSorted,
  sortDirection,
  handleSort,
}: AlertDashboardColumnTitleProps) => {
  if (column === AlertDashboardColumn.ACTIONS) {
    // No need to display this.
    return <th scope="col"></th>;
  }

  const isSortable = SORTABLE_COLUMNS.includes(column as any);

  const handleClick = (e: React.MouseEvent) => {
    if (!isSortable) return;
    e.stopPropagation();
    if (handleSort) handleSort(column);
  };

  let sortIcon = null;
  if (isSortable && isSorted && sortDirection === "asc") {
    sortIcon = (
      <ArrowUp
        className="ml-1 w-4 h-4 text-blue-600 inline align-middle"
        aria-label="sorted ascending"
      />
    );
  } else if (isSortable && isSorted && sortDirection === "desc") {
    sortIcon = (
      <ArrowDown
        className="ml-1 w-4 h-4 text-blue-600 inline align-middle"
        aria-label="sorted descending"
      />
    );
  }

  return (
    <th
      scope="col"
      onClick={isSortable ? handleClick : undefined}
      style={!isSortable ? { cursor: "default" } : {}}
    >
      <span className="relative flex items-center w-full">
        {AlertDashboardColumnTooltip[column as keyof typeof AlertDashboardColumnTooltip] ? (
          <Tooltip
            title={
              AlertDashboardColumnTooltip[
                column as keyof typeof AlertDashboardColumnTooltip
              ] as string
            }
          >
            <span className="flex items-center overflow-hidden pr-6">
              <Text variant="h6" className="mr-1 truncate">
                {column}
              </Text>
              <Info size={16} className="align-middle mr-1" />
            </span>
          </Tooltip>
        ) : (
          <span className="flex items-center overflow-hidden pr-6">
            <Text variant="h6" className="mr-1 truncate">
              {column}
            </Text>
          </span>
        )}
        {isSortable && sortIcon && (
          <span className="absolute right-0 top-1/2 -translate-y-1/2">{sortIcon}</span>
        )}
      </span>
    </th>
  );
};

export default AlertDashboardColumnTitle;
